/**
 * Returns whitelist based on whether the user is new or existing.
 * @param {boolean} newUser
 * @returns {Object}
 */
export function getApiKeyFormWhitelist(newUser) {
    return {
        first_name: newUser,
        last_name: newUser,
        email: newUser,
        password: newUser,
        password_confirmation: newUser,
        agreed_tac: newUser,
        what_data: true,
        what_for: true,
        est_volume: true,
        website: true,
        location: true,
        phone: true,
        business_segment: true,
        business_subsegment: true,
    };
}
